<script setup lang="ts">
import { PageType } from '@/models/pages'

definePageMeta({
  type: PageType.Logout,
})
const authStore = useAuthStore()
if (process.client && authStore.isAuthenticated)
  performLogout()
else if (!authStore.isAuthenticated)
  customNavigateTo('/')
</script>
